import { ContactDataDto } from '@bo-client/shared/models/contactDataDto';
import { ConnectionObject } from '@bo-client/shared/models/connectionObject';
import { ConnectionObjectAdditionalInfoModel } from '@bo-client/activation-management/shared/models/connection-object-additional-info.model';
import { DocumentDtoModel } from '@bo-client/shared/models/documentDto';
import { MeteringConceptModel } from '@bo-client/activation-management/shared/models/meteringConceptModel';
import {
  FeedingPlantTypeEnum,
  FeedInManagementInfoEnum,
  GridRegistrationTypeEnum,
  MeterOperatorEnum,
  PowerGenerationSourceEnum
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { StorageModel } from '@bo-client/activation-management/grid-registration/model/storage.model';
import { ProducerModel } from '@bo-client/activation-management/grid-registration/model/producer.model';
import { PVModuleModel } from '@bo-client/activation-management/grid-registration/model/pv-module.model';
import { ActivityDto } from '@bo-client/shared/models/activityDto';
import { RequestModel } from '@bo-client/shared/models/request.model';
import { CompanyLocationDto } from '@bo-client/shared/models/companyLocations';
import { GridRegistrationReferenceModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { BankAccountModel } from '@bo-client/shared/models/bankAccountModel';
import { SepaMandateModel } from '@bo-client/shared/models/sepaMandateModel';
import { PaymentTypeEnum } from '@bo-client/shared/constants/enums';
import { CompensationCategoryModel } from '@bo-client/activation-management/shared/models/compensationCategoryModel';

export class FeederContractModel extends RequestModel {
  contractType: string;
  commissioningDate?: Date;
  meterInstallationDate?: Date;
  deviceNo?: string;
  compensationCategories?: CompensationCategoryModel[];
  gridRegistrationType: GridRegistrationTypeEnum;
  customer: ContactDataDto = {};
  invoiceContact: ContactDataDto = {};
  connectionObject: ConnectionObject = {};
  connectionObjectAdditionalInfo: ConnectionObjectAdditionalInfoModel =
    new ConnectionObjectAdditionalInfoModel();
  uniqueCoId: string;
  companyLocation: CompanyLocationDto;
  uploads: DocumentDtoModel[] = [];
  meteringConcept: MeteringConceptModel = new MeteringConceptModel();
  powerGenerationSource: PowerGenerationSourceEnum;
  meterOperator: MeterOperatorEnum;
  isEEGExtention: boolean;
  feedingPlantType: FeedingPlantTypeEnum;
  producers: ProducerModel[] = [];
  storages: StorageModel[] = [];
  pvModules: PVModuleModel[] = [];
  activities: ActivityDto[];
  storageConcept: MeteringConceptModel = new MeteringConceptModel();
  feedInManagementInfo: FeedInManagementInfoEnum;
  consumptionOver30kw: boolean;

  hasDifferentInvoiceContact = false;
  hasStorage = false;

  comment: string;

  shortDescription?: string;
  longDescription?: string;

  // End Customer fields
  bankAccount?: BankAccountModel;
  paymentType?: PaymentTypeEnum;
  sepaMandate?: SepaMandateModel;
  customerToken?: string;
  plantOperatorAndEndUserAreIdentical?: boolean;
  maStRNumberProducer?: string;
  maStRNumberStorage?: string;
  maStRNumber?: string;
  maStRAcceptedDeclaration: boolean;
  maStRRegistrationDate: Date;
  ustNr: string;
  taxNr: string;
  ustPflichtig: boolean;
  steuerArt: string;
  gridRegistration?: GridRegistrationReferenceModel;
  acceptedUstConditions: boolean;
  externalId?: string;
  externalGridRegistrationId?: string;
  assignedTransformerStation?: string;
  confirmationWithoutContract?: boolean;

  // New fields
  maStRSELNumber?: string; // MaStR Nr. der Stromerzeugungslokation der Einheit
  maStREEGNumber?: string; // MaStR Nr. der Erzeugungsanlage (EEG Nummer)
  maStRSSENumberStorage?: string; // MaStR SSE des Speichers
  maStREEGNumberStorage?: string; // MaStR EEG der Erzeugungsanlage (SEE Nummer)
  batteryTechnology?: string; // Batterietechnologie
  batteryType?: string; // Batterietyp (LIT, ...)
  usageType?: string; // MaStR Nutzungsart
  orientation?: string; // Ausrichtung
  tilt?: string; // Neigung
  secondaryOrientation?: string; // Nebenausrichtung
  secondaryTilt?: string; // Neigung Nebenausrichtung
  eegProducerKey?: string; // EEG-Anlagenschlüssel der Erzeugungseinheit
  eegStorageKey?: string; // EEG-Anlagenschlüssel der Speichereinheit

  customerTaxIdentificationNumber?: string; // Steueridentifikationsnummer
  fullFeedInBonusRequested: boolean;
}

export class ConfirmFeederContractModel {
  contractType: string;
  commissioningDate?: Date;
  meterInstallationDate?: Date;
  deviceNo?: string;
  compensationCategories?: CompensationCategoryModel[];
  invoiceContact?: ContactDataDto;
  plantOperatorAndEndUserAreIdentical?: boolean;
  maStRNumberProducer?: string;
  maStRNumberStorage?: string;
  maStRNumber?: string;
  maStRAcceptedDeclaration: boolean;
  maStRRegistrationDate: Date;
  ustNr: string;
  taxNr: string;
  ustPflichtig: boolean;
  steuerArt: string;
  bankAccount?: BankAccountModel;
  paymentType?: PaymentTypeEnum;
  sepaMandate?: SepaMandateModel;
  producers: ProducerModel[] = [];
  storages: StorageModel[] = [];
  acceptedUstConditions: boolean;
}

export class FeederContractReferenceModel {
  id: number;
}

export enum FeederContractStatusEnum {
  ToBeCreated = 'ToBeCreated',
  Created = 'Created',
  TechnicallyReviewed = 'TechnicallyReviewed',
  ConfirmationRequestedByMail = 'ConfirmationRequestedByMail',
  Accepted = 'Accepted',
  Confirmed = 'Confirmed',
  Cancelled = 'Cancelled',
  FeedbackNeeded = 'FeedbackNeeded',
  Completed = 'Completed',
  ClosedWithoutFeedback = 'ClosedWithoutFeedback'
}
